import { render, staticRenderFns } from "./AppToolbarItemPeriod.vue?vue&type=template&id=4bdf48d5&lang=pug&"
import script from "./AppToolbarItemPeriod.vue?vue&type=script&lang=js&"
export * from "./AppToolbarItemPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports